import React from "react";

export enum ContentType {
    POST = "post",
    COMMENT = "comment",
}

export type Content = {
    commentCount: number;
    content: string;
    contentType: ContentType;
    createdAt: string;
    id: number;
    parentContent: string | null;
    reactionCount: Record<string, number>;
    user: {
        activeState: string;
        allowToContact: boolean;
        avatar: string | null;
        gender: string;
        isActive: boolean;
        role: string;
        screenName: string;
        uuid: string;
    };
};

export type ContentListItemType = {
    content: Content;
    onItemClick: (content: Content) => void;
    avatarIconOverlay?: React.ReactNode;
    stringsToHighlight?: string[];
};
